const typography = {
  fontFamily: "arial",
  body1: {
    lineHeight: 1.15,
    color: "#000000",
  },
  fontWeightBold: 700,
};

export default typography;
